import React from "react";

const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-r from-rose-700 to-rose-900 text-white">
      <div className="absolute inset-0 bg-black opacity-30"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-32">
        <div className="max-w-3xl">
          <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-6">
            Connect with Energy Communities Worldwide
          </h1>

          <p className="text-xl md:text-2xl mb-8 text-rose-100">
            Join discussions, share knowledge, and collaborate with energy
            enthusiasts and professionals from around the globe.
          </p>

          <div className="flex flex-wrap gap-4">
            <a
              href="/app"
              className="px-8 py-3 bg-white text-rose-700 font-medium rounded-lg shadow-lg hover:bg-rose-50 transition-colors"
            >
              Join the Community
            </a>

            <a
              href="/app"
              className="px-8 py-3 bg-transparent border border-white text-white font-medium rounded-lg hover:bg-white/10 transition-colors"
            >
              Browse Discussions
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-white to-transparent"></div>
    </section>
  );
};

export default HeroSection;
